import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { keys } from '../keys'
import { fetchPicks, fetchPickStats } from '../fetchers/picks'

interface UsePicksOptions {
    filterId?: string
    type?: 'folder' | 'collection' | 'hashtag' | 'unsorted' | 'favourites'
}

export const usePicks = ({ filterId, type = 'folder' }: UsePicksOptions = {}) => {
    const contextKey = filterId ? `${type}-${filterId}` : (type === 'folder' ? 'home' : type)
    
    return useInfiniteQuery({
        queryKey: keys.picks.context(contextKey),
        queryFn: ({ pageParam = 0 }) => fetchPicks({ filterId, type, pageParam }),
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages) => lastPage.hasMore ? allPages.length : undefined,
        refetchInterval: (query) => {
            const pages = query.state.data?.pages as { picks: any[] }[] | undefined;
            if (!pages) return false;
            const hasSkeleton = pages.some(page => page.picks?.some(p => p.isLoading));
            return hasSkeleton ? 2000 : false;
        }
    })
}

export const usePickStats = () => {
    return useQuery({
        queryKey: keys.picks.stats(),
        queryFn: fetchPickStats,
        staleTime: 1000 * 30, // 30 seconds
    })
}
